import axios from 'axios';
import store from '@/store';

const apiPath = `${store.state.apiPathWithVersion}/user`;

export default {
  async unsubscribe(payload) {
    if (process.env.NODE_ENV === 'development') {
      return {
        data: {},
        error: false
      };
    }
    let apiUrl = store.state.countrySelected.api;
    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/unsubscribe`, payload);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  noActivated() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.status === 'NO_TELETAG_ACTIVED';
    }
    return false;
  },

  registeredWithBle() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.registeredWithBle;
    }
    return false;
  },

  registeredWithBleDate() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.registeredWithBleDate;
    }
    return null;
  },

  registeredWithBleDateLocal() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.registeredWithBleDateLocal;
    }
    return null;
  },

  noPhoneValidated() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.status === 'NO_PHONE_VALIDATED';
    }
    return false;
  },

  sentLetter() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.status === 'REQUEST_LETTER';
    }
    return false;
  },

  isActived() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.status === 'ACTIVED';
    }
    return false;
  },

  shoudPayLetter() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null && typeof store.state.user.isLetterPayable !== 'undefined') {
      return store.state.user.isLetterPayable;
    }
    return true;
  },

  hadBalance() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.balance > 0;
    }
    return false;
  },

  hadActiveTags() {
    if (typeof store.state.user !== 'undefined' && store.state.user !== null) {
      return store.state.user.activeTags;
    }
    return false;
  }
};
